import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgSelectConfig } from '@ng-select/ng-select';

export interface SelectOption<T = string> {
  label: string;
  id: T;
  disabled?: boolean;
}

@Component({
  selector: 'sky-select[options]',
  template: `
    <label
      *ngIf="label"
      class="flex items-center text-sm cursor-text font-semibold mb-1"
      [class.text-sky-grey]="control.disabled"
      [class.text-sky-red]="control.touched && control.invalid"
      [class.text-sky-blue]="focused"
      ><span>{{ label }}</span> <sky-tooltip-badge *ngIf="tooltip" [message]="tooltip"></sky-tooltip-badge
    ></label>
    <ng-select
      [class.focused]="focused"
      [class.error]="control.touched && control.invalid"
      [class.text-sky-grey]="control.disabled"
      [class.text-xs]="smallSized"
      [formControl]="control"
      [placeholder]="placeholder"
      [multiple]="multiselect"
      [clearable]="clearable"
      [closeOnSelect]="!multiselect"
      [items]="options"
      (change)="valueChange.emit($event)"
      (focus)="focused = true"
      (blur)="focused = false"
      [searchable]="false"
    >
    </ng-select>
    <span class="text-xs text-red-700" *ngIf="ifErrorVariable">{{ errorMessages }}</span>
  `,
  styles: [
    `
      :host {
        display: block;
        position: relative;
      }
    `,
  ],
})
export class SkySelectComponent<T> {
  @Input() public control!: FormControl;
  @Input() public smallSized = false;
  @Input() public label = '';
  @Input() public ifErrorVariable = false;
  @Input() public errorMessages = '';
  @Input() public tooltip?: string;
  @Input() public placeholder = 'Kliknij i wybierz z listy';
  @Input() public options!: Array<SelectOption<T>> | null;
  @Input() public multiselect = false;
  @Input() public clearable = true;
  @Output() public valueChange = new EventEmitter();

  public focused = false;

  constructor(private readonly _config: NgSelectConfig) {
    this._config.notFoundText = 'Nie znaleziono wyników';
    this._config.bindValue = 'id';
    this._config.bindLabel = 'label';
  }
}
